export const getStaffLeaveCellHeight = (itemsCount) => {
  const cellBaseHeight = 48

  if (2 >= itemsCount) {
    return cellBaseHeight
  }

  return (itemsCount * (cellBaseHeight / 2))
}
